<template>
    <Head title="Companion Pass" />
    <div class="px-4 md:px-8">
        <CompanionPass />
    </div>
</template>

<script setup>
import { Head } from '@inertiajs/vue3';
import CompanionPass from '@/components/companion-pass/companion-pass.vue';
</script>
